var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"req-status"},[(!_vm.data || _vm.data.length < 1)?_c('p',{staticClass:"no_data"},[_vm._v(_vm._s(_vm.$lange == "en" ? "No Data" : "暂无数据"))]):_c('e-charts',{staticStyle:{"width":"100%"},attrs:{"options":_vm.options,"auto-resize":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }